import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { SharedService } from '../shared/shared.service';
import { SettingsService } from '../settings/settings.service';
import { OrderService } from '../order/shared/order.service';

import * as auth0 from 'auth0-js';
import * as jwtDecode from 'jwt-decode';

import { environment as env } from '../../environments/environment';

import 'rxjs/add/operator/filter';

@Injectable()
export class AuthService {
    prot: string = window.location.protocol;
    loc: string = window.location.hostname;
    port: string = window.location.port ? ':' + window.location.port : '';
    auth0 = new auth0.WebAuth({
        clientID: '1MtRKreftaX1cJyI6J8wSHO6W4PoyvBn',
        domain: 'slog.auth0.com',
        responseType: 'token id_token',
        audience: env.apiUrl,
        // redirectUri: this.prot + '//' + this.loc + this.port + '/callback',
        redirectUri: env.redirectUri,
        scope: 'openid profile role email'
    });
    public user: any;

    constructor(
        public router: Router,
        private http: HttpClient,
        public sharedService: SharedService,
        public settingsService: SettingsService,
        public orderService: OrderService
    ) {}

    public login(): void {
        this.auth0.authorize();
        // this.auth0.authorize({
        //     connection: 'ebias'
        // });
    }

    public handleAuthentication(): void {
        this.auth0.parseHash((error, authResult) => {
            if (authResult && authResult.accessToken && authResult.idToken) {
                console.log(authResult);
                this.user = jwtDecode(authResult.idToken);
                this.setRoleForNonEbiasUsers();
                localStorage.setItem('user', JSON.stringify(this.user));
                window.location.hash = '';
                this.setSession(authResult);
                this.sharedService.getProductGroups().subscribe();
                this.sharedService.getSuppliers().subscribe();
                // this.sharedService.getAllProducts().subscribe();
                // this.sharedService.reportVareStatusProdukt().subscribe();
                this.orderService.getFavoritesForUser(this.user.role).subscribe();

                this.sharedService.getFinishedOrders().subscribe();
                this.sharedService.getOpenOrders().subscribe();
                this.settingsService.getProjects().subscribe();
                this.settingsService.getAccounts().subscribe();
                this.settingsService.getAvdelinger().subscribe();
            } else if (error) {
                this.router.navigate(['/dashboard']);
                // return false;
                console.log(error);
            } else {
                this.sharedService.getProductGroups().subscribe();
                this.sharedService.getSuppliers().subscribe();
                // this.sharedService.getAllProducts().subscribe();
                // this.sharedService.reportVareStatusProdukt().subscribe();
                this.orderService.getFavoritesForUser(JSON.parse(localStorage.getItem('user')).role).subscribe();

                this.sharedService.getFinishedOrders().subscribe();
                this.sharedService.getOpenOrders().subscribe();
                this.settingsService.getProjects().subscribe();
                this.settingsService.getAccounts().subscribe();
                this.settingsService.getAvdelinger().subscribe();
            }
        });
    }

    private setRoleForNonEbiasUsers(): void {
        if (!this.user.role) {
            const sub = this.user.sub;
            if(sub) {
                if (sub.includes("google-oauth2")) {
                    const key = Object.keys(this.user).find((key) =>
                        key.includes("app_metadata")
                    );
                    if (key) {
                        const app_metadata = this.user[key];
                        if (app_metadata.slog && app_metadata.slog.eidsiva_group_id) {
                            this.user = {...this.user, role: "Internbruker"};
                        }
                    }
                } else if (sub.includes("eidsiva-ms-entra")) {
                    this.user = {...this.user, role: "Internbruker"};
                }
            }
        }
    }

    private setSession(authResult): void {
        // Set the time that the access token will expire at
        const expiresAt = JSON.stringify(authResult.expiresIn * 1000 + new Date().getTime());
        localStorage.setItem('access_token', authResult.accessToken);
        localStorage.setItem('id_token', authResult.idToken);
        localStorage.setItem('expires_at', expiresAt);
    }

    // tslint:disable-next-line:member-ordering
    public logout(): void {
        // Remove tokens and expiry time from localStorage
        localStorage.removeItem('access_token');
        localStorage.removeItem('id_token');
        localStorage.removeItem('expires_at');
        localStorage.removeItem('user');
        // Go back to the home route
        this.router.navigate(['/login']);
    }

    // tslint:disable-next-line:member-ordering
    public logoutEB(): void {
        localStorage.removeItem('access_token');
        localStorage.removeItem('id_token');
        localStorage.removeItem('expires_at');
        // window.location.href = 'https://ebias.eidsiva.net/connect/endsession';
        sessionStorage.clear();
        this.router.navigate(['/login']);
    }

    // tslint:disable-next-line:member-ordering
    public isAuthenticated(): boolean {
        // Check whether the current time is past the
        // access token's expiry time
        const expiresAt = JSON.parse(localStorage.getItem('expires_at'));
        return new Date().getTime() < expiresAt;
    }
}



// WEBPACK FOOTER //
// ./src/app/auth/auth.service.ts